// Central test ID constants

export const HOME = {
    emergentLink: 'home-emergent-link',
};

export const LANDING = {
    hero_browse: 'landing-hero-browse-mentors-button',
    hero_admin: 'landing-hero-admin-login-button',
    mentors_section: 'landing-mentors-section',
};

export const MENTOR_CARD = {
    root: 'mentor-card',
    view: 'mentor-card-view-profile-button',
};

export const MENTOR_PROFILE = {
    book: 'mentor-profile-book-session-button',
    availability: 'mentor-availability-list',
};

export const BOOKING = {
    duration_radio: 'booking-duration-radio',
    slot_chip: 'booking-slot-chip',
    student_email: 'booking-student-email-input',
    student_college_id: 'booking-student-college-id-input',
    student_topic: 'booking-student-topic-input',
    confirm: 'booking-confirm-button',
    close: 'booking-close-button',
    back: 'booking-back-button',
    next: 'booking-next-button',
    success_meet: 'booking-success-meet-link',
    success_calendar: 'booking-success-calendar-link',
    success_done: 'booking-success-done-button',
    reschedule_confirm: 'booking-reschedule-confirm-button',
};

export const STUDENT_DASHBOARD = {
    credits: 'student-dashboard-credits',
    email: 'student-login-email-input',
    college_id: 'student-login-college-id-input',
    submit: 'student-login-submit-button',
    logout: 'student-dashboard-logout-button',
    booking_row: 'student-dashboard-booking-row',
    cancel_button: 'student-dashboard-cancel-button',
    reschedule_button: 'student-dashboard-reschedule-button',
    feedback_button: 'student-dashboard-feedback-button',
};

export const STUDENT_FEEDBACK = {
    modal: 'student-feedback-modal',
    star: 'student-feedback-star',
    comments: 'student-feedback-comments-input',
    submit: 'student-feedback-submit-button',
    recommend_yes: 'student-feedback-recommend-yes',
    recommend_no: 'student-feedback-recommend-no',
};

export const ADMIN_SETTINGS = {
    cancel_input: 'admin-settings-cancel-hours-input',
    reschedule_input: 'admin-settings-reschedule-hours-input',
    save: 'admin-settings-save-button',
    connect_calendar: 'admin-settings-connect-calendar-button',
    disconnect_calendar: 'admin-settings-disconnect-calendar-button',
};

export const ADMIN_LOGIN = {
    email: 'admin-login-email-input',
    password: 'admin-login-password-input',
    submit: 'admin-login-submit-button',
};

export const ADMIN_NAV = {
    overview: 'admin-nav-overview',
    bookings: 'admin-nav-bookings',
    mentors: 'admin-nav-mentors',
    students: 'admin-nav-students',
    feedback_form: 'admin-nav-feedback-form',
    feedback_submissions: 'admin-nav-feedback-submissions',
    users: 'admin-nav-users',
    settings: 'admin-nav-settings',
    logout: 'admin-nav-logout',
};

export const ADMIN_STUDENTS = {
    add_button: 'admin-students-add-button',
    upload_button: 'admin-students-upload-button',
    adjust_credits: 'admin-students-adjust-credits',
    delete: 'admin-students-delete',
};

export const ADMIN_MENTORS = {
    onboarding_link: 'admin-mentors-onboarding-link',
    disconnect: 'admin-mentors-disconnect',
};

export const ADMIN_FEEDBACK_FORM = {
    add_field: 'admin-feedback-add-field',
    save: 'admin-feedback-save',
};

export const ADMIN_USERS = {
    add: 'admin-users-add',
    delete: 'admin-users-delete',
    edit: 'admin-users-edit',
    save: 'admin-users-save',
};

export const MENTOR_ONBOARDING = {
    connect: 'mentor-onboarding-connect-button',
};

export const MENTOR_FEEDBACK = {
    submit: 'mentor-feedback-submit-button',
};
